import React, { useState, useEffect, useCallback } from 'react';
import Icon from '../assets/icons/Icon';
import { useDict } from '../contexts/LanguageContext';

const ChecklistItem = ({ data }) => {
    const label = data[0];
    const meetsReq = data[1];

    const setClass = () => {
        const classArr = ['checklist__item'];
        if (meetsReq) classArr.push('checked');
        return classArr.join(' ');
    };

    return (
        <div className={setClass()}>
            {meetsReq ? (
                <Icon icon="Check" width={15} />
            ) : (
                <Icon icon="Close" width={15} />
            )}
            <span>{label}</span>
        </div>
    );
};

const PasswordChecklist = ({ password, rePassword }) => {
    const dict = useDict();

    const [contains8C, setContains8C] = useState(false);
    const [containsUL, setContainsUL] = useState(false);
    const [containsLL, setContainsLL] = useState(false);
    const [containsN, setContainsN] = useState(false);
    const [containsSC, setContainsSC] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(false);

    const validatePassword = useCallback(() => {
        setContainsUL(password.toLowerCase() !== password);
        setContainsLL(password.toUpperCase() !== password);
        setContainsN(/\d/.test(password));
        setContainsSC(
            /[!@#$%^&*,.()\-+_={}[\]{};'\\:"|\\/<>?~`]/g.test(password)
        );
        setContains8C(password.length >= 8);
        setPasswordMatch(password !== '' && password === rePassword);
    }, [password, rePassword]);

    const checklists = [
        [dict.minimum8Characters, contains8C, 1],
        [dict.upperCase, containsUL, 2],
        [dict.lowerCase, containsLL, 3],
        [dict.number, containsN, 4],
        [dict.specialCharacter, containsSC, 5],
        [dict.passwordsMatch, passwordMatch, 6],
    ];

    useEffect(() => {
        validatePassword();
    }, [validatePassword]);

    return (
        <div className="checklist__container">
            <span className="checklist__title">{dict.passwordRequirements}:</span>
            {checklists.map((checklist) => (
                <ChecklistItem className="checklist__item" data={checklist} key={checklist[2]} />
            ))}
        </div>
    );
};

export default PasswordChecklist;
